import { render, staticRenderFns } from "./EtapasFunil.vue?vue&type=template&id=347f23bf&"
import script from "./EtapasFunil.vue?vue&type=script&lang=js&"
export * from "./EtapasFunil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports